import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { MAX_RETRIES } from '#pplx/frontend/api-clients/core/utils.js';
import { parseSettings } from '#pplx/frontend/apps/ask/thread-data/dataTransformation.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const getUserSettings = async ({ skipConnectorPickerCredentials = true, headers, reason, }) => {
    try {
        const { error, data, response } = await webserveruserClient.GET('/rest/user/settings', reason, {
            params: {
                query: {
                    skip_connector_picker_credentials: skipConnectorPickerCredentials,
                },
            },
            timeoutMs: 1500,
            numRetries: MAX_RETRIES,
            headers,
        });
        if (error || !data) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: `Failed to get user settings`,
                cause: error,
                status: response.status ?? 0,
            });
        }
        const parsed = parseSettings(data);
        return parsed;
    }
    catch (err) {
        logger.error(err);
        const parsed = parseSettings({});
        return parsed;
    }
};
//# sourceMappingURL=getUserSettings.js.map